import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import OwTitle from "../OwTitle/OwTitle";
import Modal from "react-modal";

type Props = {
    titleTag?: string;
    titleIcon?: string;
    title?: string;
    message?: string;
    closeFn?: () => void;
    showAlert: boolean;
    ariaHideApp?: boolean;
};


const AlertModal = (props: Props) => {
    const close = () => {
        if (props.closeFn) {
            props.closeFn();
        }
    };

    const modalComponent = () => {
        return (
            <div className="AlertModal p-3">
                <div className={"title"}>
                    {props.title ? (
                        <OwTitle title={props.title} leftIconName={props.titleIcon} tag={props.titleTag} />
                    ) : null}
                </div>

                <div className={"message"}>{props.message ? <OwLabel title={props.message} /> : null}</div>

                <div className={"buttons d-flex justify-content-center mt-5"}>
                    <div>
                        <OwButton title={"ok"} className={"btn-danger mt-4"} fn={close} />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal
            ariaHideApp={props.ariaHideApp}
            isOpen={props.showAlert}
            onAfterClose={props.closeFn}
            contentLabel="Orderwerks"
            shouldCloseOnOverlayClick={false}
            style={{}}
            className={"modalContentClass"}
            overlayClassName={"modalOverlayClass"}>
            {modalComponent()}
        </Modal>
    );
}

export default AlertModal;
